.row {
  margin: 10px 0;
  gap: 10px;
  display: flex;
  justify-content: space-between;
}

.buttonWrapper {
  margin-top: 24px;
}
